import { createReducer, createActions } from "reduxsauce";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
	getOrganizationRequest: null,
	getOrganizationSuccess: ["organization"],
	getOrganizationFailure: null,
	setOrganizationId: ["orgID"],
	getAllAdminsRequest: null,
	getAllAdminsSuccess: ["admins"],
	getAllAdminsFailure: null,
	fetchOrganizationLogsRequest: null,
	fetchOrganizationLogsSuccess: ["logs"],
	fetchOrganizationLogsFailure: null,
	setOrganizationLoadingRequest: null,
	setOrganizationLoadingFinish: null,
	getOrganizationAppointmentsRequest: null,
	getOrganizationAppointmentsSuccess: ["appointments"],
	getOrganizationAppointmentsFailure: null,
	setRoutePermission:["routePermission"]
});

export const OrganizationTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	organization: null,
	orgID: null,
	// employees: null,
	admins: null,
	logs: null,
	appointments: null,
	loading: false,
	routePermission:{
		COUNSELING: true,
		COUNSELING_OVERVIEW: true,
		COUNSELING_BY_PROVIDER: true,
		COUNSELING_BY_PLATFORM: true,
		COUNSELING_BY_TOPIC: true,
		COUNSELING_BY_AGE: true,
		COUNSELING_BY_GENDER: true,
		COUNSELING_BY_USER_RETENTION: true,
		COUNSELING_BY_FEEDBACK: true,
		COUNSELING_BY_VISIT_OUTCOME: true,
		STRESS_TEST: true,
		STRESS_USAGE_OVERVIEW: true,
		STRESS_INDIVIDUAL_QUESTION: true,
		STRESS_BY_LEVEL: true,
		STRESS_BY_AGE: true,
		STRESS_BY_GENDER: true,
		STRESS_BY_DEPARTMENT: true,
		STRESS_BY_RETURNING: true,
		PEOPLE: true,
		PEOPLE_OVERVIEW: true,
		INDIVIDUAL_USER: true
	}
};

/* ------------- Reducers ------------- */

// request the data from an api
export const getOrganizationRequest = state => Object.assign({}, state, { loading: true });
export const getOrganizationSuccess = (state, { organization }) => (
	Object.assign({}, state, { organization, loading: false })
);
export const getOrganizationFailure = state => Object.assign({}, state, { loading: false });

export const getAllAdminsRequest = state => (Object.assign({}, state, { loading: true }));
export const getAllAdminsSuccess = (state, { admins }) => (Object.assign({}, state, { admins, loading: false }));
export const getAllAdminsFailure = state => (Object.assign({}, state, { loading: false }));

export const getOrganizationAppointmentsRequest = state => (Object.assign({}, state, { loading: true }));
export const getOrganizationAppointmentsSuccess = (state, { appointments }) => (Object.assign({}, state, { appointments, loading: false }));
export const getOrganizationAppointmentsFailure = state => (Object.assign({}, state, { loading: false }));

export const fetchOrganizationLogsRequest = state => (Object.assign({}, state, { loading: true }));
export const fetchOrganizationLogsSuccess = (state, { logs }) => (Object.assign({}, state, { logs, loading: false }));
export const fetchOrganizationLogsFailure = state => (Object.assign({}, state, { loading: false }));

export const setOrganizationLoadingRequest = state => Object.assign({}, state, { loading: true });
export const setOrganizationLoadingFinish = state => Object.assign({}, state, { loading: false });

export const setOrganizationId = (state, { orgID }) => Object.assign({}, state, { orgID, loading: false });
export const setRoutePermission = (state, { routePermission }) =>Object.assign({}, state, { routePermission, loading: false });
/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
	[Types.GET_ORGANIZATION_REQUEST]: getOrganizationRequest,
	[Types.GET_ORGANIZATION_SUCCESS]: getOrganizationSuccess,
	[Types.GET_ORGANIZATION_FAILURE]: getOrganizationFailure,
	[Types.GET_ALL_ADMINS_REQUEST]: getAllAdminsRequest,
	[Types.GET_ALL_ADMINS_SUCCESS]: getAllAdminsSuccess,
	[Types.GET_ALL_ADMINS_FAILURE]: getAllAdminsFailure,
	[Types.SET_ORGANIZATION_LOADING_REQUEST]: setOrganizationLoadingRequest,
	[Types.SET_ORGANIZATION_LOADING_FINISH]: setOrganizationLoadingFinish,
	[Types.FETCH_ORGANIZATION_LOGS_REQUEST]: fetchOrganizationLogsRequest,
	[Types.FETCH_ORGANIZATION_LOGS_SUCCESS]: fetchOrganizationLogsSuccess,
	[Types.FETCH_ORGANIZATION_LOGS_FAILURE]: fetchOrganizationLogsFailure,
	[Types.GET_ORGANIZATION_APPOINTMENTS_REQUEST]: getOrganizationAppointmentsRequest,
	[Types.GET_ORGANIZATION_APPOINTMENTS_SUCCESS]: getOrganizationAppointmentsSuccess,
	[Types.GET_ORGANIZATION_APPOINTMENTS_FAILURE]: getOrganizationAppointmentsFailure,
	[Types.SET_ORGANIZATION_ID]: setOrganizationId,
	[Types.SET_ROUTE_PERMISSION]: setRoutePermission,

});



// WEBPACK FOOTER //
// ./src/reducers/OrganizationReducer.js